import { Context } from "@nuxt/types/app";
import XLSX from "xlsx";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // for generating excel template
  function blobExcel(
    arrData: Array<Array<string | number>>,
    props: Record<string, any>,
    headerRow = 0,
  ): Blob {
    const wb: any = XLSX.utils.book_new();
    wb.Props = Object.assign(props || {}, {
      Title: "Sheet",
      Subject: "XLSX",
      Author: "",
      CreatedDate: new Date(),
    });
    wb.SheetNames.push(wb.Props.Title);
    wb.Sheets[wb.Props.Title] = XLSX.utils.aoa_to_sheet(arrData);
    
    // Calculate column width based on the longest value in each column
    const numCols = arrData[0]?.length || 0;
    const colWidths = Array.from({ length: numCols }, (_, colIndex) => {
      let maxLength = 0;
      // Check all rows to find the maximum length for this column
      for (let rowIndex = 0; rowIndex < arrData.length; rowIndex++) {
        const cellValue = arrData[rowIndex]?.[colIndex];
        if (cellValue !== undefined && cellValue !== null) {
          const cellLength = cellValue.toString().length;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        }
      }
      // Add some padding (e.g., +2) for better readability
      return { wch: Math.max(maxLength + 2, 10) };
    });
    
    wb.Sheets[wb.Props.Title]["!cols"] = colWidths;

    const wbOut = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    const buf = new ArrayBuffer(wbOut.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < wbOut.length; i += 1) {
      // eslint-disable-next-line
            view[i] = wbOut.charCodeAt(i) & 0xFF;
    }

    return new Blob([buf], { type: "application/octet-stream" });
  }

  return {
    blobExcel,
  };
}
